<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough" transform="matrix(-1,0,0,1,32,0)">
        <path
          d="M26,5C26,5.55,26.45,6,27,6C27,6,31,6,31,6C31.55,6,32,5.55,32,5C32,5,32,1,32,1C32,0.45,31.55,0,31,0C30.45,0,30,0.45,30,1C30,1,30,2.74,30,2.74C28.54,1.07,26.4,0,24,0C19.58,0,16,3.58,16,8C16,12.06,19.02,15.4,22.94,15.92C22.96,15.92,22.98,15.93,23,15.93C23.33,15.97,23.66,16,24,16C28.42,16,32,12.42,32,8C32,7.45,31.55,7,31,7C30.45,7,30,7.45,30,8C30,11.31,27.310000000000002,14,24,14C23.29,14,22.63,13.85,22,13.62C22,13.62,22,13.63,22,13.63C19.67,12.81,18,10.61,18,8C18,4.69,20.69,2,24,2C25.77,2,27.36,2.78,28.46,4C28.46,4,27,4,27,4C26.45,4,26,4.45,26,5C26,5,26,5,26,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Reset',
} as DefineComponent
</script>
